import { Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import type { BackofficeModule } from '../registry';
import { CrmPage } from './CrmPage';

/** Baustein für Anfragen, Angebote, Aufträge und Kontakte: die Wiedervorlagen am Beleg */
export { FollowUpPanel } from './FollowUps';

/**
 * Einstiegspunkt des Moduls CRM-Abteilung im Backoffice (KON-172, Schlüssel `crm`, siehe docs/auftragsmanagement.md): der Arbeitsplatz des Vertriebs unter /crm. Die Abteilung steht
 * in der Seitenleiste mit Anfragen, Angeboten und Marketing (navigation.ts), die Kontakte bei den Stammdaten.
 */
export const crmModule: BackofficeModule = {
  key: 'crm',
  path: '/crm',
  nav: [{ label: 'CRM Dashboard', path: '/crm' }],
  routes: <Route path="crm" element={<ModuleGate module="crm" permission="crm.read"><CrmPage /></ModuleGate>} />,
};
